!function (n, o) {
  "object" == typeof exports && "undefined" != typeof module ? o(exports) : "function" == typeof define && define.amd ? define(["exports"], o) : o(n.styledBy = {});
}(this, function (n) {
  "use strict";

  var o = Object.assign || function (n) {
    for (var o = 1; o < arguments.length; o++) {
      var t = arguments[o];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }

    return n;
  },
      t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
    return typeof n;
  } : function (n) {
    return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  },
      r = {
    function: function _function(n) {
      var o = n.options,
          t = n.props;
      return o[t[n.prop]](t);
    },
    string: function string(n) {
      return n.options[n.props[n.prop]];
    },
    undefined: function undefined(n) {
      var o = n.options,
          t = n.props;
      return "function" == typeof o._ ? o._(t) : null;
    }
  },
      e = {
    string: function string(n) {
      return n.options;
    },
    function: function _function(n) {
      return (0, n.options)(n.props);
    },
    object: function object(n) {
      var o = n.options,
          e = n.props,
          p = n.prop;
      return r[t(o[e[p]])]({
        options: o,
        props: e,
        prop: p
      });
    },
    undefined: function undefined() {}
  },
      p = function p(n, o) {
    return function (r) {
      return r[n] ? o ? e[void 0 === o ? "undefined" : t(o)]({
        prop: n,
        options: o,
        props: r
      }) : r[n] : "";
    };
  },
      u = function u(n) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return function (r) {
      return Object.keys(n).reduce(function (e, u) {
        return e + " " + p(u, n[u])(o({}, t, r));
      }, "");
    };
  };

  module.exports = function (n, o) {
    return "string" == typeof n ? p(n, o) : u(n, o);
  }, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});